import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Presentational chrome for a design-system modal, mirroring `bk-card`.
 * Renders the standard Bootstrap `.modal-header / .modal-body / .modal-footer`
 * structure (so it inherits the global `_modal.scss` retheme) with an optional
 * title and a close affordance. Body is the default slot; the footer is the
 * `[bk-modal-footer]` slot.
 *
 * Used inside a modal component opened via `BsModalService`; the parent wires
 * `(closed)` to `bsModalRef.hide()`.
 *
 * Usage:
 *   <bk-modal title="Edit" (closed)="bsModalRef.hide()">
 *     <form>...</form>
 *     <div bk-modal-footer><button bkButton color="primary">Save</button></div>
 *   </bk-modal>
 */
@Component({
  selector: 'bk-modal',
  templateUrl: './bk-modal.component.html',
  styleUrls: ['./bk-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BkModalComponent {
  @Input() title?: string;

  @Input()
  get dismissible(): boolean { return this._dismissible; }
  set dismissible(value: BooleanInput) { this._dismissible = coerceBooleanProperty(value); }
  private _dismissible = true;

  @Output() closed = new EventEmitter<void>();
}
